class AriaCombobox extends HTMLElement {
  constructor() {
    super();

    this.handleToggle = (e) => {
      if (e.detail.id !== this.id) return;
      this.opener = e.target;
      this._toggle();
    };

    this.closeEsc = (e) => {
      if (e.key === "Escape") {
        this._close();
      }
    };

    document.addEventListener("click", (e) => {
      if (this.contains(e.target) || this.opener?.contains(e.target)) return;

      this._close();
    });

    document.addEventListener("focusout", (e) => {
      if (
        !e.relatedTarget ||
        this.contains(e.relatedTarget) ||
        this.opener?.contains(e.relatedTarget)
      )
        return;

      this._close();
    });

    this.addEventListener("aria-listbox:focus-change", (e) => {
      if (!this.opener) return;

      this.opener.setAttribute("aria-activedescendant", e.target.id);
    });

    this.handleChange = () => {
      if (this._closeOnChange) {
        // Brief delay so user can register their change before drawer closes
        setTimeout(() => {
          this._close();
        }, 250);
      }
    };

    this.addEventListener("change", this.handleChange);
    this.addEventListener("aria-listbox:change", this.handleChange);
  }

  connectedCallback() {
    document.addEventListener("aria-combobox:toggle", this.handleToggle);
    document.addEventListener("keydown", this.closeEsc);
  }

  disconnectedCallback() {
    document.removeEventListener("aria-combobox:toggle", this.handleToggle);
    document.removeEventListener("keydown", this.closeEsc);
  }

  _toggle() {
    if (this.hasAttribute("open")) {
      this._close();
    } else {
      this._open();
    }
  }

  _open() {
    if (this.isOpen) return;
    this.removeEventListener("transitionend", this.onEnd);
    this.isOpen = true;
    this.onEnd = () => {
      this.removeEventListener("transitionend", this.onEnd);
      this.querySelector("aria-listbox-v2").setAttribute("active", "");
      this.style.height = null;
      this.style.overflow = "visible";
    };

    this.addEventListener("transitionend", this.onEnd);

    this.opener.setAttribute("aria-expanded", "true");
    this.style.setProperty("--filter-content-height", `0px`);
    // this.style.opacity = 0;
    this.style.display = null;
    this.style.overflow = "hidden";

    window.requestAnimationFrame(() => {
      this.setAttribute("open", "");

      this.style.setProperty(
        "--filter-content-height",
        `${this.scrollHeight}px`,
      );
      // this.style.opacity = 1;
    });
  }

  _close() {
    if (!this.isOpen) return;
    this.removeEventListener("transitionend", this.onEnd);

    this.onEnd = () => {
      this.removeEventListener("transitionend", this.onEnd);
      this.querySelector("aria-listbox-v2").removeAttribute("active");
      this.style.display = "none";
      this.isOpen = false;
      this.style.removeProperty("--filter-content-height");
      this.style.overflow = "visible";
    };

    this.addEventListener("transitionend", this.onEnd);

    this.style.setProperty("--filter-content-height", `0px`);
    // this.style.opacity = 0;
    this.style.overflow = null;
    this.style.overflow = "hidden";
    this.removeAttribute("open");
    this.opener.setAttribute("aria-expanded", "false");
  }

  get _closeOnChange() {
    const closeOnChangeWhenQuery =
      this.getAttribute("close-on-change-when") || null;

    if (!closeOnChangeWhenQuery) return false;

    return window.matchMedia(closeOnChangeWhenQuery).matches;
  }
}

if (!customElements.get("aria-combobox")) {
  customElements.define("aria-combobox", AriaCombobox);
}
